import type { z } from 'zod';

import { objectKeys } from './objectKeys.js';

/**
 * Builds a schema shape where keys in `keysForSchema1` get `schema1`, all others get `schema2`.
 * Preserves key-specific types: `result[k]` is `S1` when k ∈ keysForSchema1, else `S2`.
 */
export const buildSchemaShapeWithDiscriminator = <
    T extends Record<string, unknown>,
    KeysForSchema1 extends keyof T,
    S1 extends z.ZodTypeAny,
    S2 extends z.ZodTypeAny,
>({
    keysForSchema1,
    obj,
    schema1,
    schema2,
}: {
    keysForSchema1: Record<KeysForSchema1, unknown>;
    obj: T;
    schema1: S1;
    schema2: S2;
}): { [K in keyof T]: K extends KeysForSchema1 ? S1 : S2 } =>
    Object.fromEntries(objectKeys(obj).map((k) => [k, k in keysForSchema1 ? schema1 : schema2])) as {
        [K in keyof T]: K extends KeysForSchema1 ? S1 : S2;
    };
